export default __webpack_public_path__ + "static/media/polygon-transparent.e34a57e7.png";